/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Letter case, e.g. lower or upper
 * @export
 */
export const LetterCaseConstants = {
    Upper: 'Upper',
    Lower: 'Lower',
    Camel: 'Camel'
} as const;
export type LetterCaseConstants = typeof LetterCaseConstants[keyof typeof LetterCaseConstants];


export function LetterCaseConstantsFromJSON(json: any): LetterCaseConstants {
    return LetterCaseConstantsFromJSONTyped(json, false);
}

export function LetterCaseConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LetterCaseConstants {
    return json as LetterCaseConstants;
}

export function LetterCaseConstantsToJSON(value?: LetterCaseConstants | null): any {
    return value as any;
}

